import Modals from './Modals.vue';

let modalId=0;

const ModalStore = {
  state: [], // here the modals will be added
  settings: {
  },
  setOptions(options) {
    this.settings = Object.assign(this.settings, options);
  },
  removeModal(id) {
    const indexToDelete = this.state.findIndex(n => n.id === id);
    if (indexToDelete !== -1) {
      this.state.splice(indexToDelete, 1);
    }
  },
  addModal(component,props) {
    modalId++;
    const modal={component,id:modalId, props: {...this.settings, ...props}}
    this.state.push(modal)
  },
};

const ModalsPlugin = {
  install(Vue, options) {
    let app = new Vue({
      data: {
        ModalStore: ModalStore
      },
      methods: {
        showModal(c,p) {
          this.ModalStore.addModal(c,p);
        }
      }
    });
    Vue.prototype.$modal = app.showModal;
    Vue.prototype.$modalList = app.ModalStore;
    Vue.component('Modals', Modals);
    if (options) {
      ModalStore.setOptions(options);
    }
  }
};

export default ModalsPlugin;
